import { useCrudActions } from '@/common/view/useCrudActions';
import { gameService } from '@/services/game';
import useVuelidate from '@vuelidate/core';
import { integer, minValue } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useGameReport() {
    const crudAction = useCrudActions();

    const model = reactive({
        warningThreshold: 0,
        penaltyThreshold: 0,
        penaltyGame: 0,
        canRemove: false
    });

    const validations = {
        warningThreshold: { integer, minValue: minValue(0) },
        penaltyThreshold: { integer, minValue: minValue(0) },
        penaltyGame: { integer, minValue: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: gameService.report.get,
        onSuccess: ({ data }) => {
            model.warningThreshold = data.warningThreshold;
            model.penaltyThreshold = data.penaltyThreshold;
            model.penaltyGame = data.penaltyGame;
            model.canRemove = true;
        },
        onError: () => {
            model.warningThreshold = 0;
            model.penaltyThreshold = 0;
            model.penaltyGame = 0;
            model.canRemove = false;
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => gameService.report.update(model.warningThreshold, model.penaltyThreshold, model.penaltyGame),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: gameService.report.remove,
            onSuccess: fetch,
            onFinally: () => v$.value.$reset()
        })
    };

    return { model, v$, fetch, actions };
}
